import { useTheme } from '../context/ThemeContext';
import Header from './Header';
import Footer from './Footer';
import '../styles/main.css';

const Layout = ({ children }) => {
  const { theme } = useTheme();

  return (
    <div className={`app-container ${theme}-theme`}>
      <Header />
      <main className="main-content">
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default Layout;